module.exports = __webpack_public_path__ + "static/img/triste_shadow.49b0e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/triste_shadow.png
// module id = 3PMr
// module chunks = 0